var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":("tree-node-actions-" + (_vm.nodo.id))}},[_c('li',[_c('span',{staticClass:"node-activation-date"},[_vm._v("\n    "+_vm._s(_vm.activationDate)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }